import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=05cff898&scoped=true&"
import script from "./Prizes.vue?vue&type=script&lang=js&"
export * from "./Prizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cff898",
  null
  
)

export default component.exports